import { render, staticRenderFns } from "./crmInventory.vue?vue&type=template&id=0fab9cf0"
import script from "./crmInventory.vue?vue&type=script&lang=js"
export * from "./crmInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports